// extracted by mini-css-extract-plugin
export var advantages = "advantagesList-module--advantages--34swJ";
export var jsAnimInit = "advantagesList-module--jsAnimInit--2pMCv";
export var title = "advantagesList-module--title--2VyUa";
export var text = "advantagesList-module--text--2hhBi";